module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "note"
    }
  }), _vm._v("Author's Note")]), _vm._v(" "), _c('p', {
    staticClass: "text-indent"
  }, [_vm._v("Beyond my experience and education, this book is an extension of a program called Skills That Inspire Incredible Results (STIIR) that I offer to leadership teams. As a result, the thoughts, concepts and suggestions have been tested by hundreds of executives. This book is meant to be a catalyst to help each reader become even more successful. It also can be used to help sustain, throughout the STIIR Program participant's career, the effective use of the six key skills.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-559c4a72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_authorsnote.vue
// module id = 69
// module chunks = 0